export { CustomerFormFields } from './CustomerFormFields'
export { useCustomerFormFields } from './useCustomerFormFields'
export type {
  CustomerFormFieldsData,
  CustomerFormFieldControls,
  CustomerFormSectionValidation,
  CustomerCustomPropertiesConfig,
  UseCustomerFormFieldsProps,
  CustomerFormErrors,
  Contact,
  CustomerCustomProperty,
  TaxRegistrationEntry,
  TaxStatus
} from './types'
export { getCustomerContactsValidators } from './components/CustomerContactsField'
export { CustomerAliasField } from './components/CustomerAliasField'
export {
  EMPTY_CUSTOMER_FORM_ADDRESS,
  toCustomerFormAddresses,
  toCustomerAddressesFromForm
} from './customerFormAddress'
export { toCustomerContactsFromForm } from './customerFormContacts'
